import { lazy } from "react";

// project-imports
import Loadable from "components/Loadable";

/**
 * Lazy-loaded component for rendering the list of Module.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ListModulesPage - Lazy-loaded ListModulesPage component.
 */
const ListModulePage = Loadable(lazy(() => import("./ListModulePage")));

/**
 * Lazy-loaded component for rendering the add Modules page.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} AddModulesPage - Lazy-loaded AddModulesPage component.
 */
const AddModulePage = Loadable(lazy(() => import("./AddModulePage")));

/**
 * Lazy-loaded component for rendering the View Modules page.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ViewModulesPage - Lazy-loaded ViewModulesPage component.
 */
const ViewModulePage = Loadable(lazy(() => import("./ViewModulePage")));

/**
 * Lazy-loaded component for rendering the View Modules page.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ViewModulesPage - Lazy-loaded ViewModulesPage component.
 */
const EditModulePage = Loadable(lazy(() => import("./EditModulePage")));

/**
 * Array containing route definitions for the Modules-related pages.
 * @constant {Object[]} ModuleRoutes - Array of Modules route objects.
 * @property {string} ModuleRoutes[].path - The path of the Modules route.
 * @property {React.ReactElement} ModuleRoutes[].element - The React element to be rendered for the Modules route.
 */
const ModuleRoutes = [
  {
    path: "list",
    element: <ListModulePage />,
  },
  {
    path: "add",
    element: <AddModulePage />,
  },
  {
    path: "view/:module_id",
    element: <ViewModulePage />,
  },
  {
    path: "edit/:module_id",
    element: <EditModulePage />,
  },
];

export default ModuleRoutes;
